import { ProductCard } from '@theme/product-card';

/**
 * A custom element that extends ProductCard to pin a specific variant.
 * When data-selected-variant-id is present, it overrides the gallery
 * to show that variant's image and configures quick-add to add it
 * directly to cart without opening the variant picker.
 *
 * Visibility of gallery slides and Add/Choose buttons is handled by
 * scoped CSS output in the variant-card snippet; this class handles
 * the interactive parts (slideshow navigation and form input value).
 *
 * @extends {ProductCard}
 */
class VariantCard extends ProductCard {
  connectedCallback() {
    super.connectedCallback();

    setTimeout(() => {
      this.#applySelectedVariantOverrides();
    });
  }

  #applySelectedVariantOverrides() {
    const variantId = this.dataset.selectedVariantId;
    if (!variantId) return;

    const mediaId = this.dataset.selectedVariantMediaId;
    if (mediaId) {
      this.refs.slideshow?.select({ id: mediaId }, undefined, { animate: false });
    }

    for (const input of this.querySelectorAll('input[name="id"]')) {
      if (input instanceof HTMLInputElement) {
        input.value = variantId;
        input.disabled = false;
      }
    }

    const variantImageUrl = this.dataset.selectedVariantImageUrl;
    if (variantImageUrl) {
      for (const addToCart of this.querySelectorAll('add-to-cart-component')) {
        addToCart.setAttribute('data-product-variant-media', variantImageUrl);
      }
    }
  }
}

if (!customElements.get('variant-card')) {
  customElements.define('variant-card', VariantCard);
}
